export const m1 = 'APP/SET_TOGGLE_MENU'
export const showMenu = 'APP/SHOW_MENU'
export const showHeader = 'APP/SHOW_HEADER'
export const showFooter = 'APP/SHOW_FOOTER'
export const menuFolded = 'APP/MENU_FOLDED'



// WEBPACK FOOTER //
// ./src/app/_default/store/mutations-types.js